import { useContext, useEffect, useState } from 'react';
import { useDrag } from 'react-dnd';
import { Item, ItemTypes, MovableTypePrintingContext } from './MovableTypePrintingProvider';

interface GamePrintingMovableTypeProps extends Item {
  squareIndex?: number,
}

export default function GamePrintingMovableType(props: GamePrintingMovableTypeProps) {
  const { answers, setAnswer } = useContext(MovableTypePrintingContext);
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.CHARACTER,
    item: props,
    collect: (monitor) => {
      // console.log('abc');
      document.body.style.userSelect = 'none';
      return ({
        isDragging: !!monitor.isDragging()
      })
    },
    end: (_item, _monitor) => {
      document.body.style.userSelect = 'auto';
      // console.log('end', item, monitor, monitor.didDrop(), props.squareIndex);

      if (undefined !== props.squareIndex) {
        // const didDrop = monitor.didDrop()
        // if (!didDrop) {
        setAnswer(props.squareIndex, null);
        // console.log('setAnswer', monitor);
        // }
      }
    },
  }))
  const [isDropped, setIsDropped] = useState(false);

  useEffect(() => {
    setIsDropped(answers.some((ans) => null !== ans && ans.imgIndex === props.imgIndex));
  }, [answers, props.imgIndex]);

  return (
    <div ref={drag} data-text={props.text} data-index={props.imgIndex} className={`game-printing-movable-type game-printing-movable-type-pos-${(undefined !== props.squareIndex) ? 'static' : props.posAlias}`} style={{
      opacity: (undefined !== props.squareIndex) ? 1 : (isDropped ? 0.2 : (isDragging ? 0.5 : 1)),
      // textDecoration: isDropped ? "underline" : 'none',
    }}>
      <div className={`movable-type-character ${props.text.match(/^[\u0000-\u007f]*$/) ? 'en' : 'zh'}`}>
        <div><div className="shadow">{props.text}</div><div className="offset">{props.text}</div><div className="text">{props.text}</div></div>
      </div>
    </div>
  )
}
